import { BaseRouteService } from 'core/services';

class ProductHistoryRouteService extends BaseRouteService {
    constructor() {
        super('product-histories');
    }

    find(filter) {
        return super.find(this.base + '/{?productId,searchQuery,page,rpp,sort,embed,fields}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }
}

export default ProductHistoryRouteService;
